import { DataService } from '../../services/data.service';
import { StoreService } from '../../services/store.service';
import { ToolsService } from '../../services/tools.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomRegister } from '../../models/models';
import { SecurityContext } from '@angular/core';
import { Waiver } from 'src/app/models/waiver';
import { WaiverService } from 'src/app/services/waiver.service';
import { CustomFields, optionValue } from 'src/app/models/custom-fields';
import { CustomFieldType } from 'src/app/alv-enums';

export class BaseComponent {

	public registerId: number;
	public kioskId: number;

	private themeWrapper = document.querySelector('body');

	constructor(protected dataService: DataService
		, public storeService: StoreService
		, protected toolsService: ToolsService
		, protected activatedRoute: ActivatedRoute
		,protected router:Router
	) { }

	protected watchRouteParams() {
		const self = this;

		self.activatedRoute.paramMap.subscribe(params => {
			self.registerId = +params.get('registerId');
			self.kioskId = +params.get('kioskId');
			self.storeService.gatewaySubscriptionName = `kiosk_${self.registerId}_${self.kioskId}`;
			self.setupGateway();
			self.getKioskSettings(self.registerId);
		});
	}

	protected getKioskSettings(registerId: number) {
		const self = this;

		self.dataService.get<CustomRegister>(`/CustomRegisters/${registerId}`)
			.then(response => {
				self.toolsService.ProcessHttpResponse(response, () => {
					const customRegister = response.data;

					if (customRegister) {
						self.storeService.kioskSettings.primaryColor = customRegister.primaryColor;
						self.storeService.kioskSettings.isDisablePaperReceipt = customRegister.isDisablePaperReceipt;
						self.storeService.kioskSettings.thankYouPageText = customRegister.thankYouPageText;
						self.storeService.kioskSettings.landingPageImage = customRegister.landingPageImage;
						self.storeService.kioskSettings.imagePath = customRegister.imagePath;
						self.storeService.kioskSettings.callNameLabel = customRegister.callNameLabel;
						self.storeService.kioskSettings.inActivityTimerInSec = customRegister.inActivityTimerInSec ? customRegister.inActivityTimerInSec : 120;
						self.storeService.kioskSettings.timerAfterTransactionInSec = customRegister.timerAfterTransactionInSec ? customRegister.timerAfterTransactionInSec : 8;
						self.storeService.kioskSettings.showEmail = customRegister.showEmail;
						self.storeService.kioskSettings.locationId = customRegister.locationId;
						self.storeService.kioskSettings.enableCreditSwipe = customRegister.enableCreditSwipe;
						self.storeService.kioskSettings.enableManualCredit = customRegister.enableManualCredit;
						self.storeService.kioskSettings.hideInfoStep = customRegister.hideInfoStep;
						self.storeService.kioskSettings.removeOnScreenKeyboard = customRegister.removeOnScreenKeyboard;
						self.storeService.kioskSettings.allowCashPaymentAtCounter = customRegister.allowCashPaymentAtCounter;
						self.storeService.kioskSettings.waiverRequired = customRegister.waiverRequired;
						self.storeService.kioskSettings.waiverId = customRegister.waiverId;
						self.storeService.kioskSettings.isEnableKiosk = customRegister.isEnableKiosk;
						self.storeService.kioskSettings.kioskEnabled = customRegister.kioskEnabled;
						self.storeService.kioskSettings.enableTicketPrint = customRegister.enableTicketPrint;
						self.storeService.kioskSettings.disableProductPurchase = customRegister.disableProductPurchase;
						self.storeService.kioskSettings.disableScanOption = customRegister.disableBarCodeScan;
						self.storeService.kioskSettings.recaptcha_Key = customRegister.recaptcha_Key;
						self.storeService.kioskSettings.recaptcha_Keyv2 = customRegister.recaptcha_Keyv2;
					self.storeService.kioskSettings.gatewayProcessor = customRegister.gatewayProcessor;
					self.storeService.kioskSettings.tenantName = customRegister.tenantName;
				self.storeService.kioskSettings.enableStripeTerminalReader = customRegister.enableStripeTerminalReader;
				self.storeService.kioskSettings.useStripeSimulatedReader = customRegister.useStripeSimulatedReader;
				self.storeService.kioskSettings.stripeTerminalUrl = customRegister.stripeTerminalUrl;
				self.storeService.kioskSettings.defaultStripeReaderId = customRegister.defaultStripeReaderId;
					if (self.storeService.kioskSettings.waiverRequired && self.storeService.kioskSettings.waiverId) {
							self.dataService.get<any>(`/Waiver/GetWaiver/?id=${self.storeService.kioskSettings.waiverId}`)
								.then(response => {
									self.toolsService.ProcessHttpResponse(response, () => {
										const waiverData = response.data;
										self.storeService.waiver = new Waiver();
										let waiver = self.storeService.waiver;
										waiver.waiverId = waiverData.waiverId;
										waiver.waiverTemplateId = waiverData.waiverTemplateId
										waiver.waiverName = waiverData.waiverName;
										waiver.waiverText = waiverData.waiverText;
										waiver.minAgeOfConsent = waiverData.minAgeOfConsent;
										waiver.isRequireAcknowledgement = waiverData.isRequireAcknowledgement;
										waiver.requirePasswordToLoadGuestData = waiverData.isRequirePasswordToLoadGuestData;
									})
								})
						}
						self.themeWrapper.style.setProperty('--primaryColor', self.storeService.kioskSettings.primaryColor);
					}
					if(self.storeService.kioskSettings.isEnableKiosk == false)
					{
						if (self.registerId) {
							if (self.kioskId) {
								self.router.navigate([`/dashboard/${self.registerId}/${self.kioskId}`]);
							} else {
								self.router.navigate([`/dashboard/${self.registerId}`]);
							}
						}
					}
				});
			});
	}

	protected setupGateway() { }


}
